import { isEqual, isNil, isObject, transform } from 'lodash';

export const areObjectValuesPresent = (obj?: { [key: string]: any }) => {
  return Object.values(obj || {}).some((value) => !isNil(value));
};

export const getObjectsDifference = <T extends object>(
  object: T,
  base: T,
): Partial<T> => {
  function changes<S extends object>(object: S, base: S) {
    return transform<S, S>(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] =
          isObject(value) && isObject(base[key])
            ? changes(value, base[key] as S[keyof S] & object)
            : value;
      }
    });
  }

  return changes(object, base);
};
